import { Injectable } from '@angular/core';

import { AlertController, LoadingController } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/observable/defer';
import 'rxjs/add/operator/mergeMap';


import { HttpClient } from '@angular/common/http';
import { ToastController } from 'ionic-angular';

import { ConfigService } from '../../providers/dbservice/configservice';


@Injectable()
export class AuthService {


  loading: any;
  currentUser: Observable<any> = null;
  controllerBaseURI;
  authState: any;
  isLoggedIn: boolean = false;
  privs: any;

  constructor(
    public loadingCtrl: LoadingController,
    public alertCtrl: AlertController, private toastCtrl: ToastController,
    private configService: ConfigService,
    public http: HttpClient) {
    this.controllerBaseURI = configService.getConfig('CONTROLLER_URL');
    // console.log('AuthService constructor');

    //   this.afAuth.authState.subscribe((auth) => {
    //  this.authState = auth;
    // });

  }

  sendNotification(message: string): void {
    let notification = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    notification.present();
  }

  login(mb_email_id: string, mb_password): Observable<any> {
    return this.dbCol({ "action": "login", "mapObject": "member", "mb_email_id": mb_email_id, "mb_password": mb_password });
  }

  dbCol(options): Observable<any> {

    return this.http.post(this.controllerBaseURI, options);
  }

  doLogout(): any {
    console.log('AuthService doLogout');
    this.isLoggedIn = false;
    this.privs = undefined;
    this.currentUser = null;
  }

}



// WEBPACK FOOTER //
// ./src/providers/dbservice/authservice.ts